import { Button, ModalProps } from 'antd';
import { useEffect, useRef, useState } from 'react';
import OrganizationUnitUpdateStaffsForm, {
  OrganizationUnitUpdateStaffsFormRefProps
} from './OrganizationUnitUpdateStaffsForm';
import { messages, organizationUnitsMessages } from 'messages';
import { Modal } from 'components/common';

type UpdateStaffModalProps = ModalProps & {
  organizationUnitId?: number;
  onClose?: () => void;
};

const UpdateStaffModal = ({ organizationUnitId, onClose, ...props }: UpdateStaffModalProps) => {
  const [loading, setLoading] = useState(false);

  const staffStatusFormRef = useRef<OrganizationUnitUpdateStaffsFormRefProps>(null);

  useEffect(() => {
    if (!props.open && staffStatusFormRef.current) {
      staffStatusFormRef.current.form.resetFields();
    }
  }, [props.open, staffStatusFormRef.current]);

  return (
    <Modal.Headless
      {...props}
      classNames={{ content: 'bg-colorBgBody' }}
      maskClosable={false}
      centered
      destroyOnClose
      footer={[
        <Button
          key='btn-submit'
          loading={loading}
          onClick={() => {
            if (staffStatusFormRef.current) {
              staffStatusFormRef.current.form.submit();
            }
          }}
          size='large'
          type='primary'
        >
          {messages.saveButtonText}
        </Button>
      ]}
      title={organizationUnitsMessages.updateStaffs}
    >
      {organizationUnitId && (
        <OrganizationUnitUpdateStaffsForm
          organizationUnitId={organizationUnitId}
          onChangeSuccess={onClose}
          ref={staffStatusFormRef}
          onChangeLoading={setLoading}
        />
      )}
    </Modal.Headless>
  );
};

export default UpdateStaffModal;
